import Input from 'components/Input';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';

const ShortTextOption = (props) => {
  const { data, isPreview, viewOnly } = props;

  return isPreview ? (
    <Input
      className={`${data.meta_data && data.meta_data.unit ? 'w-83 flex items-center gap-2' : 'w-89.5'} `}
      classNameInput="flex items-center !rounded-lg"
      placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_SHORT_TEXT}
    >
      {data.meta_data && data.meta_data.unit && <span>{data.meta_data.unit}</span>}
    </Input>
  ) : (
    <>
      <Input
        value={data.answer}
        readOnly
        placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_SHORT_TEXT}
        className={`!h-6 ${viewOnly && 'mb-4 flex items-center gap-1'}`}
        classNameInput={`!w-50 border-0 bg-transparent border-b border-dashed !border-gray-102/65 !p-0 !h-6 ${data.answer ? '!text-black-102' : '!text-gray-102/65'}`}
      >
        {data.meta_data && data.meta_data.unit && <span>{data.meta_data.unit}</span>}
      </Input>
    </>
  );
};

export default ShortTextOption;
